import { MDBCol, MDBRow } from "mdbreact";
import { Form, Input, Button, Select, message } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useAuth } from "../../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const db = getDatabase(Firebase);
const GroupTypeActionLayout = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");
	const [form] = Form.useForm();
	const [languageArray] = useListVals(ref(db, "talmidsdb/languages"));

	const handleCreate = (values) => {
		if (!canCreateAdminConfig) {
			message.error("You do not have permission to create group types.");
			return;
		}
		var object = {
			typeName: values.typeName,
			code: values.code,
			translations: {},
		};
		if (values.translations) {
			values.translations.forEach(translation => {
				if (translation.languageId && translation.text) {
					object.translations[translation.languageId] = translation.text;
				}
			});
		}

		if (values.translations?.[0]?.text) {
			object.typeName = values.translations[0].text;
		}

		const objectID = uuidv4();
		object.id = objectID;

		props.createCallback("groupTypes", objectID, object);
		form.resetFields();
	}

	const handleFailed = (err) => {
		message.error("Unable to create community: the form has errors: " + err.message)
	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol className="px-4">
					<Form
						layout="vertical"
						form={form}
						disabled={!canCreateAdminConfig}
						onFinish={handleCreate}
						onFinishFailed={handleFailed}
					>
						<Form.Item
							label="Group Type Name"
							name="typeName"
							rules={[{ required: true, message: 'Please input group Type name!' }]}
						>
							<Input
								type="text"
								placeholder="enter group type name"
								className="w-100 mr-4"
							/>
						</Form.Item>
						<Form.Item
							label="Group Type Code"
							name="code"
							rules={[{ required: true, message: 'Please input type code!' }]}
						>
							<Input
								type="text"
								placeholder="enter group type code"
								className="w-100 mr-4"
							/>
						</Form.Item>
						<Form.List name="translations">
							{(fields, { add, remove }) => (
								<div>
									{fields.map(({ key, name, ...restField }) => (
										<div key={key} style={{ display: 'flex', marginBottom: 8, alignItems: 'flex-end' }}>
											<Form.Item
												{...restField}
												name={[name, 'languageId']}
												label={fields.length > 1 ? '' : 'Language'}
												rules={[{ required: false, message: 'Please select a language!' }]}
												style={{ flex: 1, marginRight: 8 }}
											>
												<Select
													placeholder="Select language"
													showSearch
													optionFilterProp="children"
													filterOption={filterSelectOption}
													filterSort={sortSelectOptions}
												>
													{languageArray?.map((item, index) => (
														<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
													))}
												</Select>
											</Form.Item>

											<Form.Item
												{...restField}
												name={[name, 'text']}
												label={fields.length > 1 ? '' : 'Translation'}
												rules={[{ required: false, message: 'Please enter translation!' }]}
												style={{ flex: 2, marginRight: 8 }}
											>
												<Input
													placeholder="Enter translation"
													className="w-100"
												/>
											</Form.Item>

											{fields.length > 0 && (
												<Form.Item>
													<MinusCircleOutlined
														onClick={() => remove(name)}
														style={{ color: 'red', marginBottom: 24 }}
													/>
												</Form.Item>
											)}
										</div>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={(e) => {
												e.preventDefault();
												add();
											}}
											disabled={!canCreateAdminConfig}
											block
											icon={<PlusOutlined />}
										>
											Add Translation
										</Button>
									</Form.Item>
								</div>
							)}
						</Form.List>
						<Button type="primary" htmlType="submit" disabled={!canCreateAdminConfig}>
							Create
						</Button>
					</Form>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default GroupTypeActionLayout;
